import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ProductSerialService } from 'app/services/models/product-serial.service';
import { ProductService } from 'app/services/models/product.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-product-create-serialno',
  templateUrl: './product-create-serialno.component.html',
  styleUrls: ['./product-create-serialno.component.scss']
})
export class ProductCreateSerialnoComponent implements OnInit {

  @Input() data: any;
  public seriNo: string = '';

  constructor(public ngbModal: NgbActiveModal, private productSerialService: ProductSerialService, private toastrService: ToastrService,private productService:ProductService) { }

  ngOnInit(): void {
    console.log(this.data);
  }

  closeModal() {
    this.ngbModal.close('Modal Kapatıldı.');
  }

  async createProductSerial(seriNo) {
    console.log(seriNo);
    const data = await this.productSerialService.createProductSerail(seriNo, this.data);
    if (data.status == true) {
      this.productService.sendEvent(true);
      this.toastrService.success(data.message);
    }else{
      this.toastrService.error(data.message);

    }
  }

}
